import * as yup from "yup";
import { createRichTextRequiredSchema } from "./schemaUtils";
export const schema = yup
  .object({
    work_performed: createRichTextRequiredSchema("Work description is required"),
    hours_spent: yup
      .number()
      .positive("Work hours must be positive number")
      .typeError("Work hours must be number")
      .required("Work Hours is required"),
    date_time: yup.date().required("Time is required"),
  })
  .required();
